import { createStore, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';

import { apiMiddleware } from 'ml-fetch';
import rootReducer from '../reducer/rootReducer';


const initialState = { }

function buildMiddleware() {
	const reactRouterMiddleware = routerMiddleware(browserHistory)

	if (process.env.NODE_ENV === 'development') {
		return applyMiddleware(reactRouterMiddleware, thunk, apiMiddleware, createLogger());
	} else {
		return applyMiddleware(reactRouterMiddleware, apiMiddleware, thunk);
	}
}

export default function configureStore() {
    const middleware = buildMiddleware();

    return createStore(rootReducer, initialState, middleware);
}


/** WEBPACK FOOTER **
 ** ./src/store/configureStore.js
 **/